import TutosView from "@/views/Tutos/Tutos";
import TutosList from "@/views/Tutos/TutosList";
import TutosSearch from "@/views/Tutos/TutosSearch";
import TutoView from "@/views/Tutos/TutoView";

export let Tutos;
Tutos = { TutosView, TutosList, TutosSearch, TutoView };
